<template>
  <div class="cms-youtube-cid">
    <el-dialog
      title="Insert a new Campaign"
      :visible="showCampaignModal"
      width="700px"
      top="3vh"
      :modal="true"
      @close="handleClose()"
      @open="open"
    >
      <el-form label-position="top">
        <el-form-item
            label="Name"
            :error="getValidationError('name')"
        >
          <el-input type="text" clearable v-model="newCampaign.name" />
        </el-form-item>
      </el-form>
      <el-form label-position="top">
        <el-form-item label="Description">
          <el-input type="textarea" clearable v-model="newCampaign.description" rows="5" />
        </el-form-item>
      </el-form>
      <div style="display: flex; gap: 10px">
        <el-form label-position="top" style="width: 48%; display: inline-block">
          <el-form-item
              label="Tag"
              :error="getValidationError('tag')"
          >
            <el-input type="text" clearable v-model="newCampaign.tag" />
          </el-form-item>
        </el-form>
        <el-form label-position="top" style="width: 48%; display: inline-block">
          <el-form-item
              label="Start Date"
              :error="getValidationError('start_date')"
          >
            <el-date-picker style="width: 280px"
                type="date"
                clearable
                v-model="newCampaign.start_date"
            />
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex; gap: 10px">
        <el-form label-position="top" style="width: 48%; display: inline-block">
          <el-form-item
              label="Label Share(%)"
              :error="getValidationError('label_share')"
          >
            <el-input
                type="number"
                clearable
                v-model="newCampaign.label_share"
                @input="updatePlatformShare"
                :max="100"
            />
          </el-form-item>
        </el-form>
        <el-form label-position="top" style="width: 48%; display: inline-block">
          <el-form-item
              label="Platform Share(%)"
          >
            <el-input
                type="number"
                :value="newCampaign.platform_share"
                disabled
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      active: false,
      newCampaign: {
        name: '',
        tag: '',
        start_date: new Date(),
        description: '',
        label_share: '',
        platform_share: ''
      }
    }
  },
  computed: {
    ...mapState('revShareCampaigns', ['loading', 'campaign', 'showCampaignModal','validation',]),
  },

  methods: {
    ...mapActions('revShareCampaigns', ['insertCampaign']),
    ...mapMutations('revShareCampaigns', ['setCampaignModal','setValidation']),

    submit() {
      this.insertCampaign(this.newCampaign)
      console.log(this.newCampaign)
    },

    open(){
      this.newCampaign = {
        name: '',
        description: '',
        tag: '',
        start_date: new Date(),
        label_share: '',
        platform_share: ''
      }
    },
    // Handle the close event and reset validation
    handleClose() {
      this.setCampaignModal(false);  // Close the modal
      this.setValidation({});         // Reset validation state
    },
    // Method to get the first error message or empty string
    getValidationError(field) {
      const errors = this.validation[field];
      return errors && errors.length > 0 ? errors[0] : ''; // Get the first error message
    },
    // Update platform share automatically
    updatePlatformShare() {
      let labelShare = parseFloat(this.newCampaign.label_share) || 0;

      if (labelShare > 100) {
        this.newCampaign.label_share = 100; // Enforce max 100
        labelShare = 100;
      }

      this.newCampaign.platform_share = 100 - labelShare; // Auto-calculate platform share
    },
  }
}
</script>

<style scoped lang="scss">

</style>
